import { Badge, Icon } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import SideView from '../side-view';
import NotificationList from './notification-list';
import TaskList from './task-list'
import { HubConnectionBuilder } from '@microsoft/signalr';
import './notifications.less';
import { infoNotification } from './notificationService';
import { IdentityProps, withIdentity } from '../../core/services/authentication';
import { UserProfileProps, withUserProfile } from "../user-profile";
import { useDispatch } from "react-redux";
import { refreshTableTimeSheetToggle } from "../../stores/actions/TimeSheet";
import { refreshTableEmployeeToggle } from '../../stores/actions/Employee';
import { refreshTableTaskToggle } from '../../stores/actions/taskTemplate';
interface Props extends WithTranslation, UserProfileProps, IdentityProps { }

const ShellNotification: FC<Props> = (props) => {
    const { t } = props;
    const [notificationNumber, setNotificationNumber] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const [reload, setReload] = useState(-1);
    const [reloadProcess, setReloadProcess] = useState(-1);
    const dispatch = useDispatch();
    const handleRefreshTable = (value: boolean, option: string) => {  
        switch (option) {
            case 'timesheet':
                dispatch(refreshTableTimeSheetToggle(value));               
                break;
            case 'employee':
                dispatch(refreshTableEmployeeToggle(value));
                break;
            case 'taskTemplate':
                dispatch(refreshTableTaskToggle(value));
                break;
            default:
                break;
        }        
    }; 

    useEffect(() => {
        const connection = new HubConnectionBuilder().withUrl(`${process.env.PUBLIC_URL}/hubs/notifications`).withAutomaticReconnect().build();
        connection
            .start()
            .then(() => {
                connection.on('NewNotification', (data: any) => {
                    if (data.userId.toUpperCase() === props.identity.id?.toString().toUpperCase()) {                      
                        setReload(data.unreadNotification * new Date().getTime());
                        setNotificationNumber(data.unreadNotification);
                        infoNotification(t('New Notification'), t(data.notification.description));
                        setReloadProcess(new Date().getTime());             
                        if (data.notification.name === 'Timesheet insertion') handleRefreshTable(true, 'timesheet');
                        else if (data.notification.name === 'Employee insertion') handleRefreshTable(true, 'employee');
                        else if (data.notification.name === 'Task insertion') handleRefreshTable(true, 'taskTemplate');
                    }
                });
                connection.on('NewProcess', (data: any) => {
                    if (data.userId.toUpperCase() === props.identity.id?.toString().toUpperCase()) {
                        setReloadProcess(new Date().getTime())
                    }
                });
            })

            .catch((e: Error) => console.log('Connection failed: ', e));
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const roles = props.userProfile.roles;

    return (
            <>
                {props.children}
                <div className={'messageFloating'}>
                    <TaskList reload={reloadProcess} />
                    <div
                        data-testid="openNotificationsButton"
                        className={notificationNumber > 0 ? 'floating-container messages' : 'floating-container nomessages'}
                        onClick={() => {
                            setIsOpen(!isOpen);
                        }}
                    >
                        <Badge count={notificationNumber}>
                            <Icon type={"notification"} style={{ fontSize: '32px', marginTop: 12 }} />
                        </Badge>
                    </div>
                </div>
                <SideView className="notifications-flyout" mask={true} onClose={() => setIsOpen(false)} visible={isOpen}>
                    <NotificationList reload={reload} visible={isOpen} setNotificationCount={(count: number) => setNotificationNumber(count)} />
                </SideView>
            </>
    );
};

export default withIdentity(withUserProfile(withTranslation()(ShellNotification as any)) as any);
